module.exports = __webpack_public_path__ + "img/RedteaSIM 2@2x.20a31815.png";